import { StorageService } from '@wlp/ui-bs-oauth';
import { ExtractUtilInterface } from './../../../extract/extract-util.interface';
import { BilletCreateDataFilterPipe } from './billet-create-data-filter.pipe';

import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { UserInfoService } from '@wlp/ui-bs-login';
import * as moment from 'moment';

import { AccountPaymentRechargeBilletResponse, BilletService, BilletTypeEnum } from '@wlp/ui-bs-cashin';
import { BilletDto} from '@wlp/ui-px-cashin';
import { ModalBilletReviewChargingComponent } from 'src/app/views/themes/sentinel/modals/modal-billet-review-charging/modal-billet-review-charging.component';
import { ModalAlertBilletComponent } from 'src/app/views/themes/sentinel/modals/modal-alert-billet/modal-alert-billet.component';
import { ExtractUtil } from '../../../extract/extract-util';
import { LoadingService } from '../../../../../../../../../core/layout/services/loading.service';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BrMaskDirective } from "br-mask";

@Component({
  selector: 'ui-t-billet-create',
  templateUrl: './billet-create.page.html',
  styleUrls: ['./billet-create.page.scss'],
  providers: [BilletCreateDataFilterPipe, CurrencyPipe],
})
export class CharginBilletCreatePage extends ExtractUtil implements ExtractUtilInterface, OnInit {

  //valores dos cards
  public pendingValue: any;
  public pendingQuantity: any;
  public compensatedValue: any;
  public compensatedQuantity: any;
  public canceledValue: any;
  public canceledQuantity: any;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  public currentStatus: string = "";
  public isProd: boolean = environment.production;
  public uuidLotBillet: string;
  isUuidLotBillet: boolean = false;
  lot: any;

  constructor(
    public pipeFilter: BilletCreateDataFilterPipe,
    public pipeCurency: CurrencyPipe,
    public detection: ChangeDetectorRef,
    private accountChargingService: BilletService,
    protected userInfoService: UserInfoService,
    public modalController: ModalController,
    public activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private navCtrl: NavController,
    private translate: UiBsTranslateService,
    private router: Router,
    private storage: StorageService,
    public brMask: BrMaskDirective,){
    super(userInfoService, pipeFilter, detection, modalController, loadingService);
  }

  public async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    await this.loadUser();

    this.pendingValue = 0;
    this.canceledValue = 0;
    this.compensatedValue = 0;

    this.pendingQuantity = 0;
    this.canceledQuantity = 0;
    this.compensatedQuantity = 0;
  }

  ionViewWillEnter() {
    this.loadingService.show();
    this.storage.get('uuidLotBillet').then(uuidLotBillet => {
      setTimeout(() => {
        this.loadingService.hide();
        if (uuidLotBillet != undefined) {
          this.uuidLotBillet = uuidLotBillet;
          this.isUuidLotBillet = true;
          this.listReceipts = [];
          this.viewAllBilletsLot();
          this.getAllStatusDataByUuidAccountPaymentLotBillet(uuidLotBillet, 'COMPENSATED');
          this.getAllStatusDataByUuidAccountPaymentLotBillet(uuidLotBillet, 'PENDING');
          this.getAllStatusDataByUuidAccountPaymentLotBillet(uuidLotBillet, 'CANCELED');
        } else {
          this.getBillets();
          this.getAllStatusDataByStatus(undefined, 'COMPENSATED');
          this.getAllStatusDataByStatus(undefined, 'PENDING');
          this.getAllStatusDataByStatus(undefined, 'CANCELED');
        }
      }, 2000);
    })
  };

  public viewAllBilletsLot() {
    this.accountChargingService
      .getLotListBillets(this.userProfile.uuidAccount, this.uuidLotBillet)
      .pipe(
        take(1)
      ).subscribe((listBillets) => {
        this.lot = listBillets.lot;
        this.listReceipts = listBillets.billets;
        this.setArrayForShowReceipts(true);
        this.calcPaginationReceipts();
      },
      (err) => {
        console.error(err);
        this.loadingService.hide();
      },
      () => {
        this.loadingService.hide();
        this.cdr.detectChanges();
      }
    );
  };
  ionViewWillLeave() {
    this.storage.remove('uuidLotBillet');
  }

  public filterByStatus(status: string) {
    this.loadingService.show();
    let newList = this.listReceipts.filter((newArray) => {
      if (newArray.billetStatus === status) return newArray;
    });
    if (this.currentStatus != "" && this.currentStatus === status) {
      this.loadingService.hide();
      this.listReceiptsShow = this.listReceipts;
      this.currentStatus = "";
    } else {
      this.loadingService.hide();
      this.listReceiptsShow = newList;
      this.calcPaginationReceiptShow();
    }
    this.currentStatus = status;
  }

  showQuantity(quantity: any) {
    const param = {
      amount: quantity > 0 ? quantity : 0,
    };
    return param;
  }

  private getBillets(initial?: Date) {
    // await this.loadUser();
    this.loadingService.show();
    if (initial === undefined) {
      initial = this.calInitialDate;
    }
    this.dateExtractInit = moment(initial);
    this.dateExtractEnd = moment(this.calEndDate);
    const dateInitial = new DatePipe('en-US').transform(this.formattedDate(initial), 'yyyy-MM-dd');
    const dateEnd = new DatePipe('en-US').transform(this.formattedDate(this.calEndDate), 'yyyy-MM-dd');
    const type = BilletTypeEnum.CHARGING;

    this.accountChargingService
      .getChargingBillets(dateInitial, dateEnd)
      .subscribe(
        (res) => {
          this.listReceipts = res as BilletDto[];
          // atualiza o front da tabela
          this.setArrayForShowReceipts(true);
          this.calcPaginationReceipts();
        },
        (err) => {
          console.error(err);
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
          this.cdr.detectChanges();
        }
      );
  }

  checkStatus(status) {
    if (status) {
      return 'Vencido';
    } else {
      return 'Válido';
    }
  }

  getTransaction(transactionId: string) {
    this.accountChargingService.getBilletsByTransactionId(transactionId).subscribe((res) => {
      this.showExtract(res);
    });
  }

  async showExtract(data: AccountPaymentRechargeBilletResponse) {
    let billetForm = {
      dateDue: moment(this.formattedDate(data.billetDueTime)).format('DD/MM/YYYY'),
      document: data.documentPayer,
      nameComplete: data.namePayer,
      descripiton: data.requestDescription,
      billetValue: data.value,
    };
    const modal = await this.modalController.create({
      component: ModalBilletReviewChargingComponent,
      cssClass: 'modal-custom-class',
      componentProps: {
        billetRequest: false,
        billet: billetForm,
        billetResponse: data,
        data: data,
      },
      backdropDismiss: false,
    });
    return await modal.present();
  }

  async showCanceled(data: AccountPaymentRechargeBilletResponse) {
    let billetForm = {
      dateDue: moment(this.formattedDate(data.billetDueTime)).format('DD/MM/YYYY'),
      document: data.documentPayer,
      nameComplete: data.namePayer,
      descripiton: data.requestDescription,
      billetValue: data.value,
    };
    const modal = await this.modalController.create({
      component: ModalAlertBilletComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        titleBtnConfirm: 'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.CANCEL',
        message: 'Deseja cancelar o boleto?',
      },
      backdropDismiss: false,
    });
    return await modal.present();
  }

  public filterByDayReceipts(event: Event, days?: number) {
    this.calEndDate = new Date();
    this.resetBtnFilters(); // reseta os botoes

    // aplica o estilo para o botao clicado
    const element: HTMLElement = event.target as HTMLElement;
    element.classList.add('primary');

    // caso for por date
    if (days !== undefined) {
      const date = moment(this.calEndDate).subtract(days, 'days').toDate();
      this.getBillets(date);
      this.getAllStatusDataByStatus(date, 'COMPENSATED');
      this.getAllStatusDataByStatus(date, 'PENDING');
      this.getAllStatusDataByStatus(date, 'CANCELED');
      this.dateExtractInit = moment(date);
      this.dateExtractEnd = moment(this.calEndDate);
      // toggle para o botao de perido
      this.flagDateFilter = false;
      return;
    }
    // caso for selecionar o periodo (apresenta os campos de periodo)
    this.toggleDateFilter();
  }

  public filterByDateReceipts() {
    this.resetBtnFilters();
    if (this.filterInitialDate === null || this.filterEndDate === null) return;
    // aplica as datas aos filtros
    this.calInitialDate = this.filterInitialDate;
    this.calEndDate = this.filterEndDate;
    this.dateExtractInit = moment(this.filterInitialDate);
    this.dateExtractEnd = moment(this.filterEndDate);
    this.getBillets(); // chama o metodo de busca por data
    this.getAllStatusDataByStatus(undefined, 'COMPENSATED');
    this.getAllStatusDataByStatus(undefined, 'PENDING');
    this.getAllStatusDataByStatus(undefined, 'CANCELED');
  }

  implantationColor(status) {
    switch (status) {
      case 'PENDING': {
        return 'text-pending';
      }
      case 'COMPENSATED': {
        return 'text-compensated';
      }
      case 'CANCELED': {
        return 'text-canceled';
      }
      case 'DRAFT': {
        return 'text-draft';
      }
      case 'ERROR': {
        return 'text-canceled';
      }
      case 'LIMIT_OPERATION': {
        return 'text-canceled';
      }
      default: {
        return '';
      }
    }
  }

  implantationTranslate(status) {
    switch (status) {
      case 'PENDING': {
        return 'Pendente';
      }
      case 'CANCELED': {
        return 'Cancelado';
      }
      case 'COMPENSATED': {
        return 'Compensado';
      }
      case 'DRAFT': {
        return 'Rascunho';
      }
      case 'ERROR': {
        return 'Erro proc.';
      }
      case 'LIMIT_OPERATION': {
        return 'Limite Op.';
      }
      default: {
        return '--';
      }
    }
  }

  private getAllStatusDataByUuidAccountPaymentLotBillet(uuidAccountPaymentLotBillet: string ,status?: string) {
    let type = BilletTypeEnum.CHARGING;
    this.accountChargingService
      .getAllStatusDataByUuidAccountPaymentLotBillet(this.userProfile.uuidAccount, uuidAccountPaymentLotBillet, type, status)
      .subscribe(
        (res) => {
          switch (status) {
            case 'PENDING': {
              this.pendingValue = res.totalValue;
              this.pendingQuantity = res.quantity;
              break;
            }
            case 'CANCELED': {
              this.canceledValue = res.totalValue;
              this.canceledQuantity = res.quantity;
              break;
            }
            case 'COMPENSATED': {
              this.compensatedValue = res.totalValue;
              this.compensatedQuantity = res.quantity;
              break;
            }
          }
          // atualiza o front da tabela
          this.setArrayForShowReceipts(true);
          this.calcPaginationReceipts();
        },
        (err) => console.error(err),
        () => this.cdr.detectChanges()
      );
  }

  getAllStatusDataByStatus(initial?: Date, status?: string) {
    if (initial === undefined) {
      initial = this.calInitialDate;
    }
    const dateInitial = new DatePipe('en-US').transform(this.formattedDate(initial), 'yyyy-MM-dd');
    const dateEnd = new DatePipe('en-US').transform(this.formattedDate(this.calEndDate), 'yyyy-MM-dd');
    let type = BilletTypeEnum.CHARGING;
    this.accountChargingService
      .getAllStatusDataByStatus(this.userProfile.uuidAccount, type, status, dateInitial, dateEnd)
      .subscribe(
        (res) => {
          switch (status) {
            case 'PENDING': {
              this.pendingValue = res.totalValue;
              this.pendingQuantity = res.quantity;
              break;
            }
            case 'CANCELED': {
              this.canceledValue = res.totalValue;
              this.canceledQuantity = res.quantity;
              break;
            }
            case 'COMPENSATED': {
              this.compensatedValue = res.totalValue;
              this.compensatedQuantity = res.quantity;
              break;
            }
          }
          // atualiza o front da tabela
          this.setArrayForShowReceipts(true);
          this.calcPaginationReceipts();
        },
        (err) => console.error(err),
        () => this.cdr.detectChanges()
      );
  }
  
  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }
}
